import {settingsActionsTypes} from "../constants/ActionTypes";

let userLocale = '';
if (localStorage.getItem('userLocale')) {
  userLocale = localStorage.getItem('userLocale');
}

const initialState = {
  locales: {},
  defaultLocale: '',
  locale: userLocale
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case settingsActionsTypes.SET_AVAILABLE_LOCALES:
      return Object.assign({}, state, {
        locales: action.locales,
        defaultLocale: action.defaultLocale,
        state: state.locale === '' ? action.defaultLocale : state.locale
      });

    case settingsActionsTypes.SET_LOCALE:
      return Object.assign({}, state, {locale: action.locale});

    default: break;
  }

  return state;
};

export default settings;


// WEBPACK FOOTER //
// ./reducers/settings.reducers.js